import React from 'react';
import AvatarIcon, { avatarIcon } from 'components/features/utils/AvatarIcon';

type Props = {
  icon: avatarIcon;
};

export const TimeOverComment: React.FC<Props> = props => {
  return (
    <div>
      <div className="flex flex-row items-center">
        <AvatarIcon icon={props.icon} />
        <div className="ml-4 text-base font-bold">
          目標時期を過ぎてしまっています
        </div>
      </div>
      <div className="mt-2 text-sm">
        目標期限を過ぎています。再度「目標を立て直す」から目標の設定を修正してください。
      </div>
    </div>
  );
};
